import {
    FETCH_CATEGORIES_SUCCESS,
    FETCH_SUBCATEGORY_SUCCESS,
    FETCH_CATEGORY_STATS_SUCCESS,
    ADD_CATEGORY_SUCCESS,
    DELETE_CATEGORY_SUCCESS,
    UPDATE_CATEGORY_SUCCESS,
    FETCH_SUBCATEGORY_DETAILS_SUCCESS,
} from "actions/category";

const initialState = {
    categories: [],
    currentSubCategory: null,
    categoryStats: [],
    subCategoryDetails: null,
};

const categoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload,
            };
        case FETCH_SUBCATEGORY_SUCCESS:
            return {
                ...state,
                currentSubCategory: action.payload,
            };
        case FETCH_CATEGORY_STATS_SUCCESS:
            return {
                ...state,
                categoryStats: action.payload,
            };
        case ADD_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    [action.payload.category]: {
                        ...action.payload,
                        subCategories: [],
                    },
                },
            };
        case DELETE_CATEGORY_SUCCESS:
            const newCategories = { ...state.categories };
            delete newCategories[action.payload];
            return {
                ...state,
                categories: newCategories,
            };
        case UPDATE_CATEGORY_SUCCESS:
            return {
                ...state,
                categories: {
                    ...state.categories,
                    [action.payload.category]: {
                        ...state.categories[action.payload.category],
                        ...action.payload,
                    },
                },
            };
        case FETCH_SUBCATEGORY_DETAILS_SUCCESS:
            return {
                ...state,
                subCategoryDetails: action.payload,
            };
        default:
            return state;
    }
};

export default categoryReducer;
